import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Users } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-24 px-4 bg-warmwhite" data-id="element-369">
      <div className="max-w-4xl mx-auto" data-id="element-370">
        <div className="text-center mb-12" data-id="element-371">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-372">
            ¿Este material es para vos?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-373">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 rounded-2xl border border-cream-dark" data-id="element-374">
            <div className="flex items-center gap-3 mb-6" data-id="element-375">
              <GraduationCap className="text-terracota" size={28} data-id="element-376" />
              <h3 className="text-xl font-bold text-green" data-id="element-377">
                Está pensado para docentes de:
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-378">
              {['Escuelas técnicas con orientación en alimentos', 'Escuelas agropecuarias con módulo de industrialización', 'Bachilleratos técnicos en tecnología de alimentos', 'Formación profesional en procesamiento de alimentos', 'Materias de industrialización, tecnología o procesamiento', 'Talleres de proyectos productivos con base alimentaria'].map((item, i) => <li key={i} className="flex items-start gap-2 text-ink text-sm" data-id="element-379">
                  <span className="text-olive font-bold" data-id="element-380">•</span> {item}
                </li>)}
            </ul>
            <div className="mt-6 pt-6 border-t border-cream-dark" data-id="element-381">
              <p className="text-sm font-bold text-green" data-id="element-382">
                Nivel educativo principal:
              </p>
              <p className="text-sm text-slate" data-id="element-383">
                Secundaria técnica y formación profesional
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-384">
            <div className="bg-white p-6 rounded-2xl border border-cream-dark shadow-sm" data-id="element-385">
              <h4 className="font-bold text-terracota mb-2" data-id="element-386">
                Importante sobre las normativas:
              </h4>
              <p className="text-sm text-ink leading-relaxed" data-id="element-387">
                Los principios técnicos son aplicables en toda la región
                hispanohablante. Las normativas sanitarias y de rotulado varían
                por país y deben verificarse localmente.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-cream-dark shadow-sm" data-id="element-388">
              <div className="flex items-center gap-2 mb-2" data-id="element-389">
                <Users className="text-olive" size={20} data-id="element-390" />
                <h4 className="font-bold text-green" data-id="element-391">
                  ¿No sos docente de alimentos pero trabajás con proyectos
                  productivos?
                </h4>
              </div>
              <p className="text-sm text-ink leading-relaxed" data-id="element-392">
                El sistema también puede ser útil para instructores,
                capacitadores y coordinadores de talleres técnicos que trabajen
                con procesamiento o industrialización de alimentos.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}